import { EventSchema, EventTypeCodeEnum } from '@src/entities/Event/includes/schemas';
import { PageableSchema, SortSchema } from '@src/shared/includes/schemas';
import { z } from 'zod';

export const ListEventsSchema = z.object({
  content: z.array(EventSchema),
  empty: z.boolean(),
  first: z.boolean(),
  last: z.boolean(),
  number: z.number(),
  numberOfElements: z.number(),
  pageable: PageableSchema,
  size: z.number(),
  sort: SortSchema,
  totalElements: z.number(),
  totalPages: z.number(),
});

export const ListEventsFiltersSchema = z.object({
  endDate: z
    .string()
    .nullable()
    .refine(
      (val) => {
        return val === null || /^\d{4}-\d{2}-\d{2}$/.test(val);
      },
      {
        message: 'Invalid ISO date format (expected YYYY-MM-DD) or null',
      }
    ),
  eventTypeCodeList: z.array(EventTypeCodeEnum),
  startDate: z.string().refine(
    (val) => {
      return /^\d{4}-\d{2}-\d{2}$/.test(val);
    },
    {
      message: 'Invalid ISO date format (expected YYYY-MM-DD)',
    }
  ),
});
